import dom from "../../../../dist/jsx-render/dom";
import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import { DynPopup } from "../../../Components/DynPopup";
import { TextComponent } from "../../../Components/TextComponent";
import { WidgetMeasuresByCategory, WidgetMeasuresByCategoryColumnFilter } from "../Widgets/WidgetMeasuresByCategory";
import { CheckboxCompoment } from "../../../Components/CheckboxComponent";
import { AceEditorComponent } from "../../../Components/AceEditorComponent";
import { ListView, ListViewProps } from "../../../Components/ListView/ListView";
import { RadioButtonComponent } from "../../../Components/RadioButtonComponent";
import { SortType } from "../../../Pages/Measure/VisibilityDependency/SortCondition";

export type PopupMeasuresByCategoryComponentProps = {
    widget: WidgetMeasuresByCategory;
}

export class PopupMeasuresByCategoryComponent extends JSXComponent {
    props: PopupMeasuresByCategoryComponentProps;
    markupHeader: string;
    markupItems: string;
    styles: string;
    clientId: string;
    rowClickLayoutId: number;
    categoryId: number;
    templateId: string;
    additionalFilter: string;
    columnFilters: WidgetMeasuresByCategoryColumnFilter[];
    loadImages: boolean;
    sortFirst: string;
    sortFirstAsc: SortType = SortType.desc;
    sortSecond: string;
    sortSecondAsc: SortType = SortType.desc;

    columnFilterList: ListView;

    constructor(props: PopupMeasuresByCategoryComponentProps) {
        super(props);

        this.markupHeader = this.props.widget.props.markupHeader;
        this.markupItems = this.props.widget.props.markupItems;
        this.styles = this.props.widget.props.styles;
        this.clientId = this.props.widget.props.clientId;
        this.rowClickLayoutId = this.props.widget.props.rowClickLayoutId;
        this.categoryId = this.props.widget.props.categoryId;
        this.templateId = this.props.widget.props.templateId;
        this.additionalFilter = this.props.widget.props.additionalFilter;
        // Use spread operator to copy the array
        this.columnFilters = [...this.props.widget.props.columnFilters ?? []];
        this.loadImages = this.props.widget.props.loadImages;
        this.sortFirst = this.props.widget.props.sortFirst;
        this.sortFirstAsc = this.props.widget.props.sortFirstAsc;
        this.sortSecond = this.props.widget.props.sortSecond;
        this.sortSecondAsc = this.props.widget.props.sortSecondAsc;

    }

    onSave = (): boolean => {
        this.props.widget.props.markupHeader = this.markupHeader;
        this.props.widget.props.markupItems = this.markupItems;
        this.props.widget.props.styles = this.styles;
        this.props.widget.props.clientId = this.clientId;
        this.props.widget.props.rowClickLayoutId = this.rowClickLayoutId;
        this.props.widget.props.categoryId = this.categoryId;
        this.props.widget.props.templateId = this.templateId;
        this.props.widget.props.additionalFilter = this.additionalFilter;
        // Use spread operator to copy the array
        this.props.widget.props.columnFilters = [...this.columnFilters];
        this.props.widget.props.loadImages = this.loadImages;
        this.props.widget.props.sortFirst = this.sortFirst;
        this.props.widget.props.sortFirstAsc = this.sortFirstAsc;
        this.props.widget.props.sortSecond = this.sortSecond;
        this.props.widget.props.sortSecondAsc = this.sortSecondAsc;

        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement;
    getElement = () => {
        let listViewProps: ListViewProps = {
            model: this.columnFilters,
            allowDelete: true,
            name: "Feste Filter pro Säule",
            listItemInternalComponentType: ColumnFilterListItem
        };
        this.columnFilterList = new ListView(listViewProps);

        this.element =
            <DynPopup size="fullscreen" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
                title={Resources['WidgetClient'].widgetMeasuresByCategory}>
                <div className="d-flex flex-column h-100">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" id="settings-tab" data-toggle="tab" href="#settings" role="tab" aria-controls="settings" aria-selected="true">{Resources["WidgetClient"].tabSettings}</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="design-header-tab" data-toggle="tab" href="#design-header" role="tab" aria-controls="design" aria-selected="false">{`${Resources["WidgetClient"].designHtml} Header`}</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="design-items-tab" data-toggle="tab" href="#design-items" role="tab" aria-controls="design" aria-selected="false">{`${Resources["WidgetClient"].designHtml} Items`}</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="styles-tab" data-toggle="tab" href="#styles" role="tab" aria-controls="styles" aria-selected="false">{Resources["WidgetClient"].styles}</a>
                        </li>
                    </ul>
                    <div class="tab-content mt-2 flex-grow-1" id="myTabContent">
                        <div class="tab-pane fade h-100 show active" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                            <TextComponent model={this} field="clientId" name={Resources["WidgetClient"].clientId} />
                            <TextComponent model={this} field="rowClickLayoutId" name="Untergeordnete Layout ID" />
                            <TextComponent model={this} field="categoryId" name="Kategorie ID" />
                            <TextComponent model={this} field="templateId" name="Ereignis ID" />
                            <div>
                            <label className="form-label"> {Resources.Common.sortFirstColumnLabel} <span className="info"> ({Resources["WidgetClient"].sortInfoMessage}) </span> </label>
                                <div className="d-flex align-items-center">
                                    <TextComponent model={this} field="sortFirst" name="UniqueId" additionalCssClasses="mr-2" showLabel={false} />
                                    <RadioButtonComponent
                                        model={this}
                                        field="sortFirstAsc"
                                        options={[
                                            { description: `${Resources.Common.sortTypeDesc}`, value: 0 },
                                            { description: `${Resources.Common.sortTypeAsc}`, value: 1 }
                                        ]}
                                        name=""
                                        additionalCssClasses="sort-first"
                                        changeEvent={this.onSortTypeChanged}
                                        inline={true} />
                                </div>
                            
                        </div>
                     
                            <div>
                            <label className="form-label"> {Resources.Common.sortSecondColumnLabel} <span className="info"> ({Resources["WidgetClient"].sortInfoMessage}) </span> </label>
                            <div className="d-flex align-items-center">
                                    <TextComponent model={this} field="sortSecond" name="UniqueId" additionalCssClasses="mr-2" showLabel={false} />
                                    <RadioButtonComponent
                                        model={this}
                                        field="sortSecondAsc"
                                        options={[
                                            { description: `${Resources.Common.sortTypeDesc}`, value: 0 },
                                            { description: `${Resources.Common.sortTypeAsc}`, value: 1 }
                                        ]}
                                        name=""
                                        additionalCssClasses="sort-second"
                                        changeEvent={this.onSortTypeChanged}
                                        inline={true} />
                                </div>
                            </div>
                            <TextComponent model={this} field="additionalFilter" name="Weitere Filter" />
                            <div className="info mb-3">
                                Format: @FELD;OPERATOR;VALUE;null;LINK
                            </div>

                            {this.columnFilterList.render()}
                            <button type="button" className="btn btn-mso btn-save btn-add-filter mt-1">Neuer Filter</button>
                            <CheckboxCompoment model={this} field="loadImages" label="Bilder zu Kategoriebegriffen laden" additionalCssClasses="mt-2" />
                        </div>
                        <div class="tab-pane fade h-100" id="design-header" role="tabpanel" aria-labelledby="design-header-tab">
                            {this.renderMarkupEditor("markupHeader")}
                        </div>
                        <div class="tab-pane fade h-100" id="design-items" role="tabpanel" aria-labelledby="design-items-tab">
                            {this.renderMarkupEditor("markupItems")}
                        </div>
                        <div class="tab-pane fade h-100" id="styles" role="tabpanel" aria-labelledby="styles-tab">
                            {this.renderStylesEditor()}
                        </div>
                    </div>
                </div>
            </DynPopup>;
    }

    onSortTypeChanged = (event: Event) => {
        let inputElem = event.target as HTMLInputElement;
        let value = inputElem.value;

        this.setSortTypeValue(inputElem, parseInt(value));
    }

    setSortTypeValue(inputElement: HTMLInputElement, value: number) {
        if (inputElement.classList.contains("sort-first"))
            this.props.widget.props.sortFirstAsc = value;
        else
            this.props.widget.props.sortSecondAsc = value;
    }


    renderMarkupEditor(field: string): HTMLElement {
        return <div className="markup-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={this} field={field} isCss={false} />
            </div>
        </div>;
    }

    renderStylesEditor(): HTMLElement {
        return <div className="styles-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={this} field="styles" isCss={true} />
            </div>
        </div>;
    }


    render(): HTMLElement {
        this.getElement();

        let addButton = this.element.querySelector(".btn-add-filter") as HTMLButtonElement;
        addButton.addEventListener("click", (event: MouseEvent) => {
            this.columnFilterList.addItemForModel(new WidgetMeasuresByCategoryColumnFilter());
        });

        return this.element;
    }
}

export type ColumnFilterListItemProps = {
    model: WidgetMeasuresByCategoryColumnFilter;
}

export class ColumnFilterListItem extends JSXComponent {
    props: ColumnFilterListItemProps;
    constructor(props: ColumnFilterListItemProps) { super(props); }

    render() {
        var element = <div className="col-filter-list-item d-flex flex-row w-100">
            <TextComponent model={this.props.model} field="categoryContentId" createFormGroup={false} name="Id" additionalCssClasses="text-id" />
            <TextComponent model={this.props.model} field="filter" createFormGroup={false} name="Filter" additionalCssClasses="text-filter flex-grow-1" />
        </div>;

        return element;
    }
}
